var exports = {
  "c": "typeContainer__EeGwEZ",
};

module.exports = exports;
